import type { LinkType } from './Link';
import { MessageReasonType } from './MessageReason';
import { MessageSenderType } from './MessageSender';
import { ModelActionType } from './ModelAction';
import { PageType } from './Page';
import { SendToModelStatusType } from './SendToModelStatus';

export interface AddToCartItem {
  handle: string;
  variant_id: string | null;
  line_item_properties: Array<{ label: string; value: string }> | null;
  quantity: number;
  subscription_plan_id?: string | null;
}

export interface MessageType {
  id?: number;
  clientCorrelationId?: string;
  content: string;
  contentNew: string;
  reason: MessageReasonType;
  role: MessageSenderType;
  product_id?: string | null;
  variant_id?: string | null;
  page_type?: PageType | null;
  status?: SendToModelStatusType | null;
  replyMessageId?: number | null;
  timeout?: number | null;
  clientTimestamp?: number | null;
  action?: ModelActionType | null;
  options?: string[] | null;
  multiChoice?: boolean | null;
  links: LinkType[] | null;
  hasMoreAttachments?: boolean | null;
  hasAttachments?: boolean | null;
  attachments?: { type: string; url: string }[] | null;
  chatId?: number | null;
  mlVersion?: string;
  pageType?: PageType;
  mlBeProcessingTimeMs: number | null;
  agent_name?: string | null;
  addToCart?: AddToCartItem[] | null;
  systemMessage?: string;
}
